import { styled } from '@mui/material';
import { LoadingButton } from 'components';

export const StyledButton = styled(LoadingButton)(({ theme }) => ({
  height: theme.spacing(5),
}));
